import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase/supabase';

export const usePlatformAdminRequest = (userId) => {
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch ANY existing request (not just pending) to prevent re-application
  const fetchRequest = useCallback(async () => {
    if (!userId) { setLoading(false); return; }
    try {
      const { data, error } = await supabase
        .from('d2f_platform_admin_requests')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) console.error('fetchPlatformAdminRequest error:', error);
      setRequest(data || null);
    } catch (e) {
      console.error('fetchPlatformAdminRequest exception:', e);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { fetchRequest(); }, [fetchRequest]);

  const submitRequest = async (payload) => {
    try {
      const { data, error } = await supabase.rpc('submit_platform_admin_request', {
        p_email:                payload.email                || '',
        p_display_name:         payload.display_name         || '',
        p_bio:                  payload.bio                  || '',
        p_current_job_role:     payload.current_job_role     || '',
        p_company_organization: payload.company_organization || '',
        p_years_experience:     payload.years_experience ? parseInt(payload.years_experience, 10) : 0,
        p_linkedin_url:         payload.linkedin_url         || '',
        p_reason_for_access:    payload.reason_for_access    || '',
        p_platform_vision:      payload.platform_vision      || '',
        p_expected_usage:       payload.expected_usage       || '',
        p_availability:         payload.availability         || 'part-time',
        p_timezone:             payload.timezone             || '',
        p_portfolio_url:        payload.portfolio_url        || '',
        p_website:              payload.website              || '',
        p_social_spotify:       payload.social_spotify       || '',
        p_social_instagram:     payload.social_instagram     || '',
        p_social_soundcloud:    payload.social_soundcloud    || '',
        p_user_id:              userId                       || null,
      });

      if (error) {
        console.error('submit_platform_admin_request RPC error:', error);
        return { data: null, error: new Error(error.message || 'Failed to submit application') };
      }

      const record = typeof data === 'string' ? JSON.parse(data) : data;
      setRequest(record);
      return { data: record, error: null };
    } catch (err) {
      console.error('Unexpected submitRequest error:', err);
      return { data: null, error: err instanceof Error ? err : new Error('Failed to submit application') };
    }
  };

  return { request, loading, refetch: fetchRequest, submitRequest };
};